export default [
    '.com',
    '.net',
    '.org',
    '.co.uk',
    '.us',
    '.info',
    '.me',
    '.ca',
    '.com.au',
    '.eu',
    '.de',
    '.fr',
    '.in'
]